module.exports = __webpack_public_path__ + "static/media/picstork-hover.a475e970.svg";